import Badge, { statusTone, priorityTone } from '@/components/base/Badge';
import { useAppStore } from '@/store/AppStore';
import { PIPELINE_COLUMNS, REQUEST_STATUSES } from '@/mocks/constants';
import type { QuoteRequest, RequestStatus } from '@/types';

export default function RequestPipeline({
  requests,
  onSelect,
}: {
  requests: QuoteRequest[];
  onSelect: (r: QuoteRequest) => void;
}) {
  const { setRequestStatus } = useAppStore();

  return (
    <div className="overflow-x-auto pb-2">
      <div className="flex min-w-max gap-3">
        {PIPELINE_COLUMNS.map((column) => {
          const columnRequests = requests.filter((r) => r.status === column);
          return (
            <div key={column} className="w-64 shrink-0 rounded-lg border border-background-200 bg-background-50">
              <div className="flex items-center justify-between border-b border-background-200 px-3 py-2.5">
                <span className="text-xs font-bold text-foreground-700">{column}</span>
                <span className="rounded-full bg-white px-2 py-0.5 text-xs font-bold text-foreground-500">
                  {columnRequests.length}
                </span>
              </div>
              <div className="space-y-2 p-2">
                {columnRequests.length === 0 ? (
                  <div className="rounded-md border border-dashed border-background-200 py-6 text-center text-xs text-foreground-400">
                    Boş
                  </div>
                ) : (
                  columnRequests.map((r) => (
                    <div
                      key={r.id}
                      className="rounded-md border border-background-200 bg-white p-3 transition-colors hover:border-primary-200"
                    >
                      <button
                        type="button"
                        onClick={() => onSelect(r)}
                        className="block w-full text-left"
                      >
                        <div className="flex items-center gap-2">
                          <span className="truncate text-sm font-semibold text-foreground-900">{r.customerName}</span>
                          <Badge tone={priorityTone(r.priority)}>{r.priority}</Badge>
                        </div>
                        <div className="mt-0.5 truncate text-xs text-foreground-500">{r.service}</div>
                        <div className="mt-0.5 truncate text-xs text-foreground-400">{r.region}</div>
                      </button>
                      <div className="mt-2 flex items-center gap-1.5">
                        <Badge tone={statusTone(r.videoStatus)}>{r.videoStatus}</Badge>
                        <select
                          className="ml-auto h-7 w-28 rounded border border-background-200 bg-white px-1 text-xs text-foreground-700 focus:border-primary-400 focus:outline-none"
                          value={r.status}
                          onChange={(e) => setRequestStatus(r.id, e.target.value as RequestStatus)}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {REQUEST_STATUSES.map((s) => (
                            <option key={s} value={s}>
                              {s}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}